import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Subscription } from '@src/app/models/subscription';

@Injectable({
  providedIn: 'root'
})
// This service is used to check the users current subscription status
export class SubscriptionService {

  constructor(private readonly _baseService: BaseApiService) {  }
  
    // // returns a list of properties that match the search query
    // hasValidSubscription(): Observable<boolean[]> {
    //   const url = `/api/subscription/has-valid-subscription`;
    //   return this._baseService.get<boolean[]>(url);
    // }

      // returns if the user can add another property dependant on their subscription
      canAddAnotherProperty(): Observable<boolean> {
        const url = `/api/subscription/can-add-property`;
        return this._baseService.get<boolean>(url);
      }
      
      // returns if the user can add another property dependant on their subscription
      canAddAnotherTenancy(): Observable<boolean> {
        const url = `/api/subscription/can-add-tenancy`;
        return this._baseService.get<boolean>(url);
    }
      // returns if the user can add another property dependant on their subscription
      getCurrentPlan(): Observable<Subscription> {
        const url = `/api/subscription/get-current-plan`;
        return this._baseService.get<Subscription>(url);
      }

      getStripeSession(): Observable<any> {
        const url = `/api/subscription/get-payment-session`;
        return this._baseService.get<any>(url);
      }
}
